import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tabs } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import messages from './messages';

const ManageAffordableWaitlistV2Tabs = ({
  bedroomCounts,
  selectedBedroomCount,
  onChange,
}) => {
  const memoizedTabs = useMemo(
    () =>
      bedroomCounts.map((count) => ({
        label: (
          <FormattedMessage {...messages.bedroomTabLabel} values={{ count }} />
        ),
        value: count,
      })),
    [bedroomCounts],
  );

  return (
    <Tabs
      onChange={(event, value) => onChange(value)}
      value={selectedBedroomCount}
      tabs={memoizedTabs}
      sx={{ borderBottom: 1, borderColor: 'divider' }}
    />
  );
};

export default ManageAffordableWaitlistV2Tabs;
